export const getDefaultClientCompanyRoleModel = () => ({
    clientId: null,
    clientName: '',
    availableUsersNo: null,
    companyRoles: []
});
export const getDefaultCompanyRoleModel = () => ({
    companyId: null,
    companyName: '',
    roles: []
});
